(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("tcc-crate"), require("tcc-i18n"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define("tcc-fds-charts", ["react", "tcc-crate", "tcc-i18n", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["tcc-fds-charts"] = factory(require("react"), require("tcc-crate"), require("tcc-i18n"), require("react-dom"));
	else
		root["tcc-fds-charts"] = factory(root["react"], root["tcc-crate"], root["tcc-i18n"], root["react-dom"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__9155__, __WEBPACK_EXTERNAL_MODULE__4568__, __WEBPACK_EXTERNAL_MODULE__9249__, __WEBPACK_EXTERNAL_MODULE__9514__) => {
return 